export enum PricingType {
  Quote = 'quote',
  Order = 'order'
}

export interface PricingProduct {
  sku: string;
  quantity: number;
}

export interface GetPricingRequest {
  accountNumber?: string;
  products: PricingProduct[];
  type: PricingType;
}

export interface PricingInfo {
  sku: string;
  sell: number;
  cost: number;
  isEditable: boolean;
  minimumGP?: number;
  maximumGP?: number;
}

export interface GetPricingResponse {
  pricing: PricingInfo[];
}
